import ListV1 from '@/views/App/ReportSickDays/V1/List.vue';
import UserOverviewV2 from '@/views/App/ReportSickDays/V2/UserOverview.vue';
import UserListV2 from '@/views/App/ReportSickDays/V2/UserList.vue';
import PendingRequestListV2 from '@/views/App/ReportSickDays/V2/PendingList/List.vue';

const routesReportSickDays = [
    // V1
    {
        path: 'list-v1',
        name: 'reportSickDaysListV1',
        component: ListV1
    },


    // V2
    {
        path: 'user-overview-v2/:overviewUserId?',
        name: 'reportSickDaysUserOverviewV2',
        component: UserOverviewV2
    },
    {
        path: 'user-list-v2',
        name: 'reportSickDaysUserList',
        component: UserListV2
    },
    {
        path: 'pending-request-list-v2',
        name: 'reportSickDaysPendingRequestList',
        component: PendingRequestListV2
    },
];

export default routesReportSickDays;